import { IControl } from "Controls/Interfaces";
import { ControlEventTypes, GridEventTypes } from "Core/Events/EventTypes";
import { EventArgs } from "Core/Events";
import { CommandService, TextBlockService } from "Service";
import { IFCService } from "IFC/Service";
import { IFilter, IBaseGrid } from "Grids/Interfaces";
import { ApplicationParameter, QueryParameter } from "Core";
import { PageContext } from "Core/PageContext";
import { Util } from "_Public";
import { ExportType } from "Service/Client";

/**
 * Handler of IFC exports.
 * @hidden
 */
export class Export {
    private static exportType: IControl;

    // private static commandService: CommandService;
    // private static textBlockService: TextBlockService;

    private static ifcService: IFCService;
    private static filter: IFilter;
    private static downloadFile: IFilter;
    private static messages: IBaseGrid;

    private static selectedExportType: ExportType;

    private static exportImmediately: boolean;

    public static initialize(
        exportType: IControl,
        commandService: CommandService,
        textBlockService: TextBlockService,
        filter: IFilter,
        downloadFile: IFilter,
        messages: IBaseGrid
    ): void {
        //this.commandService = commandService;
        //this.textBlockService = textBlockService;
        this.exportType = exportType;

        this.filter = filter;
        this.downloadFile = downloadFile;
        this.messages = messages;
        this.messages.hide();

        this.exportType.on(ControlEventTypes.Change, (e) => this.exportTypeChanged(e));
        $(this.exportType.getElement()).attr("name", "ExportTypeID");

        this.ifcService = new IFCService();
        $(this.filter.getElement()).find(".dms-collapse-link").hide();

        this.exportImmediately = QueryParameter.get("apply") == "1";

        // if (QueryParameter.get("ExportTypeID") != null) {
        filter.on(GridEventTypes.ControlDataLoaded, (e) => {
            this.loadExportType();
        });
        // }
    }

    private static loadExportType(): void {
        let exportTypeId = Number(this.exportType.getValue());
        if (exportTypeId == 0) {
            return;
        }
        this.filter.setBusy(true);
        ApplicationParameter.remove("IESessionGUID");
        ApplicationParameter.remove("FileName");
        ApplicationParameter.remove("NavigateExport");
        this.messages.hide();
        this.downloadFile.hide();
        this.ifcService.getExportType(exportTypeId).then((res) => {
            this.selectedExportType = res;
            this.filter.setBusy(false);

            let formContainer = $(this.filter.getElement()).find(".dms-form-content");

            formContainer.find(".dms-ifcparameter-row").remove();

            for (let i = 0, len = res.Parameters.length; i < len; i++) {
                let parameter = res.Parameters[i];

                let parameterRow = $("<div class='dms-form-row row dms-ifcparameter-row'/>");
                let column = $(`<div class="dms-column dms-column-form col-sm" />`).appendTo(parameterRow);
                let formGroup = $(`<div class="form-group row" />`).appendTo(column);
                $(
                    `<label class="dms-form-label col-sm-4 col-form-label dms-tooltip" data-dms-tooltip="${parameter.Description}">${parameter.Description}</label>`
                ).appendTo(formGroup);

                let parameterValue = parameter.ParameterValue;
                if (QueryParameter.get(parameter.ParameterName) != null) {
                    parameterValue = QueryParameter.get(parameter.ParameterName);
                }
                let controlColumn = $(`<div class="dms-column col-sm-8">`).appendTo(formGroup);
                $(
                    `<input type="text" name="${parameter.ParameterName}" value="${parameterValue}" class="dms-ifc-parameter k-textbox dms-control-input dms-control dms-control-text" />`
                ).appendTo(controlColumn);

                formContainer.append(parameterRow);
            }
            PageContext.resizePage();

            if (this.exportImmediately) {
                this.exportImmediately = false;
                this.export();
            }
        });
    }

    private static exportTypeChanged(e: EventArgs<IControl>) {
        this.loadExportType();
    }

    public static export() {
        if (this.selectedExportType == null) {
            return;
        }
        let exportTypeId = this.selectedExportType.ExportTypeID;

        this.filter.setBusy(true);

        let parameters = $(this.filter.getElement()).find(".dms-ifc-parameter");
        let parameterValues: { [key: string]: string } = {};
        for (let i = 0, len = parameters.length; i < len; i++) {
            let param = $(parameters[i]);
            parameterValues[param.attr("name")] = param.val() as string;
        }

        this.ifcService.export(exportTypeId, parameterValues).then((res) => {
            ApplicationParameter.set("IESessionGUID", res.IESessionGUID);
            ApplicationParameter.set("FileName", res.FileName);
            ApplicationParameter.set("NavigateExport", false);
            this.messages.reload();
            this.downloadFile.reload();

            this.downloadExportFile(res.IESessionGUID, res.FileName);

            this.filter.setBusy(false);
            PageContext.resizePage();
        });
    }

    public static downloadExportFile(ieSessionGuid: string, fileName: string): void {
        if (!this.ifcService) {
            this.ifcService = new IFCService();
        }
        this.ifcService.getDownloadFile(ieSessionGuid, fileName).then((downloadFile) => {
            if (downloadFile) {
                Util.saveFileBase64(downloadFile.File, "application/octet-stream", downloadFile.FileName);
            }
        });
    }
}
